







/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MYPOSTFORUSERGETALL= createAsyncThunk(
  "MyPostForUsersGetAll/MyPostForUsersGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MyPostForUsersGetAllSlice = createSlice({
  name: "MyPostForUsersGetAllSlice",
  initialState: {
    MyPostForUsersGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfMyPostForUsersGetAll: (state) => {
        state.MyPostForUsersGetAll.loading = false
        state.MyPostForUsersGetAll.error = false
        state.MyPostForUsersGetAll.data = []
        state.MyPostForUsersGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MYPOSTFORUSERGETALL.fulfilled, (state, action) => {
      state.MyPostForUsersGetAll = {
        ...state.MyPostForUsersGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MYPOSTFORUSERGETALL.pending, (state, action) => {
      state.MyPostForUsersGetAll = {
        ...state.MyPostForUsersGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MYPOSTFORUSERGETALL.rejected, (state, action) => {
      state.MyPostForUsersGetAll = {
        ...state.MyPostForUsersGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MyPostForUsersGetAllAction = {
    MYPOSTFORUSERGETALL,
};

export { MyPostForUsersGetAllAction };
export default MyPostForUsersGetAllSlice.reducer;
export const {setInitialStateOfMyPostForUsersGetAll} = MyPostForUsersGetAllSlice.actions
